import { forwardRef, SelectHTMLAttributes } from "react";
import cn from "classnames";

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  srOnly?: boolean;
  label: string;
}
const PropertiesSelect = forwardRef<HTMLSelectElement, Props>(
  ({ id, label, srOnly, children, className, ...props }, ref) => {
    const rootClassName = cn(
      "text-sm leading-5 block border-gray-600 focus:outline-none rounded w-full bg-gray-700 text-gray-300 focus:ring-indigo-500 overflow-hidden mt-1",
      className
    );
    return (
      <div>
        <label
          htmlFor={id}
          className={srOnly ? "sr-only" : "text-sm text-gray-400 capitalize"}
        >
          {label}
          <select className={rootClassName} id={id} ref={ref} {...props}>
            {children}
          </select>
        </label>
      </div>
    );
  }
);

export default PropertiesSelect;
